export default __webpack_public_path__ + "static/media/contactPhone.2d4171b7.svg";